/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import {UI} from "../UIGenerator.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import {Util} from "../Utilities.js";
import CopyToClipboardComponent from "./CopyToClipboardComponent.jsx";
import DisplayCommand from "./DisplayCommand.jsx";
import OutputListItem from "./OutputList/OutputListItem.jsx";
import OutputList from "./OutputList/OutputList.jsx";
import ElementStatus from "./ElementStatus.jsx";
import DisplayStateHistory from "./DisplayStateHistory.jsx";
import CurrentUser from "authClient/currentUser";

class ImagesManagement extends Component {
    constructor() {
        super();
        this.state = {
            allImages: []
        }
    }


    async fetchData() {
        let allImages = await Database.table("Images", "app").getData()
        this.setState({allImages: allImages.recordset})
    }

    componentDidMount() {
        this.fetchData()
    }

    async addCertificate() {
        let userInfo = await CurrentUser.getUserInfo()

        let newToken = userInfo["custom:tenant_id"] + "::" + Util.unique.newId(120) + Util.unique.newId(10)

        UI.drawer(Util.unique.newId(10), (state, setState, close) => {
            return (<div className={"p-2"}>
                <CopyToClipboardComponent text={newToken}/>

                <DisplayCommand command={`cloud login --token ${newToken}`}/>
            </div>)

        }, (state, close) => {
            close()
        }, {
            title: "Add new Token", button: [{
                type: "save", text: "Create Token", onClick: async (state, setState, close) => {
                    await Database.table("AccessTokens", "app").insert(["indexKey", "token"], [Util.unique.newInternalId(), newToken])

                    await this.fetchData()
                    close()
                }
            }, {
                type: "abort",
                text: "Abbrechen",
                onClick: (inputState, setState, close) => {
                    close()
                }
            }]
        }).open()


    }

    async editImage(image) {
        UI.drawer(Util.unique.newInternalId(), (state, setState, close) => {
            return (<div className={"p-2"}>
                <OutputList>
                    <OutputListItem titel={"indexKey"}>
                        <span>{image.indexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Name"}>
                        <span>{image.imageName}</span>
                    </OutputListItem>
                    <OutputListItem titel={"lastChanged"}>
                        <span>{image.lastChanged}</span>
                    </OutputListItem>
                    <OutputListItem titel={"imageVersion"}>
                        <span>{image.imageVersion}</span>
                    </OutputListItem>

                    <OutputListItem titel={"Architecture"}>
                        <span>{image?.metaData?.architecture}</span>
                    </OutputListItem>

                    <OutputListItem titel={"OS"}>
                        <span>{image?.metaData?.os}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Size"}>
                        <span>{Math.round(((image?.metaData?.size ?? 0) / 1024 / 1024) * 100) / 100}MB</span>
                    </OutputListItem>

                    <DisplayStateHistory name={"Images"} elementId={image.indexKey}/>

                </OutputList>
            </div>)

        }, (state, close) => {
            close()
        }, {
            title: "Edit Image", button: [{
                type: "abort",
                text: "Abbrechen",
                onClick: (inputState, setState, close) => {
                    close()
                }
            }]
        }).open()


    }

    render() {
        let {allImages} = this.state
        return (
            <div>
                <RowDataTable
                    selectedIndex={this.state.selectedIndex}
                    iconElement={(row) => {
                        return (<div
                            className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                            <DisplayIcon iconName={"Image"} size={"1.1rem"}/>
                        </div>)
                    }}
                    buttons={(row) => {
                        return <>
                            <ElementStatus name={"Certificates"} elementId={row.indexKey}/>

                            {row?.URL !== undefined && (<>
                                <IconButtonComponent text={`Open`}
                                                     iconName={"IoEyeOutline"}
                                                     onClick={() => {
                                                         let url = "/a/" + row.URL.replace(/^\//g, '')
                                                         // open the page
                                                         UI.page().navigate({
                                                             pathname: url,
                                                         })
                                                     }}/>
                            </>)}

                            <IconButtonComponent text={`Edit `}
                                                 iconName={"IoPencilOutline"}
                                                 onClick={() => {
                                                     UI.page().navigate({
                                                         pathname: "/layout/edit",
                                                         search: '?indexKey=' + row.indexKey,
                                                         state: {data: row}
                                                     })

                                                 }}/>
                        </>

                    }}
                    data={allImages.map(item => ({
                        ...item,
                        Name: <>{item.imageName} (v{item.imageVersion}) </>

                    }))}
                    emptyState={() => {
                        return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                 text={<div className={"w-96 space-y-3"}>
                                                     <TextElement
                                                         textType={"header-lg"}> Keine test mit
                                                         dem Namen: "<span
                                                             className={"italic"}>{this.state.searchinput}</span>"
                                                         gefunden</TextElement>

                                                     <ButtonComponent iconName={"IoAdd"}
                                                                      onClick={() => {
                                                                          //AppActions.layout.newLayout()
                                                                      }}
                                                                      text={`Neue  `}/>
                                                 </div>}/></>)

                    }}
                    progressPending={!this.state.isLoadedComplete}
                    onRowClicked={(data) => {
                        this.editImage(data)

                    }}
                    onMiddleMouseClick={(data) => {
                    }}
                />

            </div>
        );
    }
}

export default ImagesManagement;